import React from 'react';
import { Box } from '@mantine/core';
import { ImageDetails } from '../../../../types/Image';

interface ImageDisplayProps {
  metadata: ImageDetails | null;
  actionBarHeight: number;
  drawerOpened: boolean;
  drawerWidth: string;
}

export const ImageDisplay: React.FC<ImageDisplayProps> = ({
  metadata,
  actionBarHeight,
  drawerOpened,
  drawerWidth
}) => {
  if (!metadata) return null;

  return (
    <Box
      style={{
        backgroundColor: '#f8f9fa',
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        top: `${actionBarHeight}px`,
        left: 0,
        right: drawerOpened ? drawerWidth : 0,
        bottom: 0,
        transition: 'right 300ms ease, width 300ms ease',
        width: drawerOpened ? `calc(100% - ${drawerWidth})` : '100%'
      }}
    >
      <img
        src={metadata.image_url || ""}
        alt={metadata.display_file_name || "Image"}
        style={{
          maxWidth: '100%',
          maxHeight: '100%',
          objectFit: 'contain',
          display: 'block' // Ensures proper sizing
        }}
      />
    </Box>
  );
};
